export enum OrgPermission {
  MedicaidEnrollment = 'MedicaidEnrollment'
}
